import cx from 'classnames';
import type { ReactNode } from 'react';
import styles from './Card.module.css';

export const Card = ({
  children,
  className
}: {
  children: ReactNode
  className?: string
}): ReactNode => {
  return (
    <div className={cx(styles.card, className)}>
      {children}
    </div>
  );
};
